import styled from 'styled-components';
import { Typ50 } from 'dc/Typ';
import LineHeaderComponent from 'challenge/common/LineHeader';

export const ElementWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  background: transparent;
  margin: 56px 0 24px;
  flex-direction: column;
`;

export const Image = styled.img`
  height: 90px;
  width: 90px;
  border-radius: 50%;
  border: 4px solid #fff;
  margin-bottom: 8px;
`;

export const TitleText = styled(Typ50)`
  color: #263238;
  white-space: nowrap;
  text-align: center;
  font-weight: 500;
`;

export const LineHeader = styled(LineHeaderComponent)`
  margin: 24px 0 16px;
`;
